import { FormControl, InputLabel, Select, InputBaseComponentProps } from '@mui/material';
import { useState } from 'react';

type DpSelectProps = InputBaseComponentProps & {
	fullwidth?: boolean;
	label?: string;
	children?: React.ReactNode;
};

export const DpSelect = ({
	value: _value,
	fullwidth,
	label,
	id,
	children,
	...props
}: DpSelectProps) => {
	const [value, setValue] = useState('');
	return (
		<FormControl variant="outlined" fullWidth={fullwidth}>
			<InputLabel htmlFor={id}>{label}</InputLabel>
			<Select
				native
				value={value}
				onChange={(event) => setValue(event.target.value as string)}
				inputProps={{
					id: 'uncontrolled-native',
					...props,
				}}
			>
				{children}
			</Select>
		</FormControl>
	);
};
